import { BaseService } from './core/BaseService';

export interface KeyEntry {
  id: string;
  provider: string;
  key: string;
  label?: string;
  created_at?: string;
}

class KeysApiService extends BaseService {
  async listKeys(): Promise<KeyEntry[]> {
    const data = await this.get('/api/keys');
    return data as KeyEntry[];
  }

  async addKey(entry: Omit<KeyEntry, 'id'>): Promise<KeyEntry> {
    return this.post<KeyEntry>('/api/keys', entry);
  }

  async useKey(provider: string): Promise<{ key: string }> {
    return this.post<{ key: string }>(`/api/keys/${provider}/use`);
  }
}

export const keysApi = new KeysApiService();
